// ClientComponents Module Index
// This file exports all the client components related functionality

// Import component creators for internal use and re-export
import { createPhotographyNavbarElements } from './Components/PhotographyNavbar.js';
import { createCoursesNavbarElements } from './Components/CoursesNavbar.js';
import { createCoursesTopHeaderElements } from './Components/CoursesTopHeader.js';
import { createCoursesAboutElements } from './Components/CoursesAbout.js';
import { createSolarInstallationTopHeaderElements } from './Components/SolarInstallationTopHeader.js';
import { createSolarInstallationNavbarElements } from './Components/SolarInstallationNavbar.js';
import { createHerbalSoapNavbarElements } from './Components/HerbalSoapNavbar.js';
import { createPhotographyHeroElements } from './Components/PhotographyHero.js';
import { createCoursesHeroElements } from './Components/CoursesHero.js';
import { createSolarInstallationHeroElements } from './Components/SolarInstallationHero.js';
import { createHerbalSoapHeroElements } from './Components/HerbalSoapHero.js';
import { createHerbalSoapProductsElements } from './Components/HerbalSoapProducts.js';
import { createHerbalSoapAboutElements } from './Components/HerbalSoapAbout.js';
import { createHerbalSoapIngredientsElements } from './Components/HerbalSoapIngredients.js';
import { createHerbalSoapCertificationsElements } from './Components/HerbalSoapCertifications.js';
import { createHerbalSoapContactElements } from './Components/HerbalSoapContact.js';
import { createHerbalSoapFooterElements } from './Components/HerbalSoapFooter.js';
import { createHerbalSoapTestimonialsElements } from './Components/HerbalSoapTestimonials.js';
import { createSolarInstallationAboutElements } from './Components/SolarInstallationAbout.js';
import { createSolarInstallationIndustriesElements } from './Components/SolarInstallationIndustries.js';
import { createSolarInstallationCertificationsElements } from './Components/SolarInstallationCertifications.js';
import { createSolarInstallationProjectGalleryElements } from './Components/SolarInstallationProjectGallery.js';
import { createSolarInstallationTestimonialsElements } from './Components/SolarInstallationTestimonials.js';
import { createSolarInstallationContactElements } from './Components/SolarInstallationContact.js';
import { createSolarInstallationQuoteElements } from './Components/SolarInstallationQuote.js';
import { createSolarInstallationCCTVServiceElements } from './Components/SolarInstallationCCTVService.js';
import { createSolarInstallationDoorLockServiceElements } from './Components/SolarInstallationDoorLockService.js';
import { createSolarInstallationIntercomServiceElements } from './Components/SolarInstallationIntercomService.js';
import { createSolarInstallationMaintenanceServiceElements } from './Components/SolarInstallationMaintenanceService.js';
import { createSolarInstallationFooterElements } from './Components/SolarInstallationFooter.js';
import { createCoursesDetailsElements } from './Components/CoursesDetails.js';
import { createCoursesTestimonialsElements } from './Components/CoursesTestimonials.js';
import { createCourseDetailDigitalMarketingElements } from './Components/CourseDetailDigitalMarketing.js';
import { createCourseDetailComputerOperatorElements } from './Components/CourseDetailComputerOperator.js';
import { createCourseDetailTextileDesigningElements } from './Components/CourseDetailTextileDesigning.js';
import { createCourseDetailImportExportElements } from './Components/CourseDetailImportExport.js';
import { createCourseDetailDressMakingElements } from './Components/CourseDetailDressMaking.js';
import { createCourseDetailBeauticianElements } from './Components/CourseDetailBeautician.js';
import { createCourseDetailElectricianElements } from './Components/CourseDetailElectrician.js';
import { createCoursesContactElements } from './Components/CoursesContact.js';
import { createCoursesEnrollmentFormElements } from './Components/CoursesEnrollmentForm.js';
import { createCoursesFooterElements } from './Components/CoursesFooter.js';
import { createPhotographyAboutElements } from './Components/PhotographyAbout.js';
import { createPhotographyServicesElements } from './Components/PhotographyServices.js';
import { createPhotographyIndustriesElements } from './Components/PhotographyIndustries.js';
import { createPhotographyGalleryElements } from './Components/PhotographyGallery.js';
import { createPhotographyTestimonialsElements } from './Components/PhotographyTestimonials.js';
import { createPhotographyContactElements } from './Components/PhotographyContact.js';
import { createPhotographyFooterElements } from './Components/PhotographyFooter.js';
import { createWeddingPhotographyGalleryElements } from './Components/WeddingPhotographyGallery.js';
import { createPortraitSessionsGalleryElements } from './Components/PortraitSessionsGallery.js';
import { createEventPhotographyGalleryElements } from './Components/EventPhotographyGallery.js';
import { createCommercialWorkGalleryElements } from './Components/CommercialWorkGallery.js';
import { createNatureLandscapeGalleryElements } from './Components/NatureLandscapeGallery.js';
import { createHerbalSoapDetailElements } from './Components/HerbalSoapDetail.js';
import { createUbtanDetailElements } from './Components/UbtanDetail.js';
import { createHerbalFacewashDetailElements } from './Components/HerbalFacewashDetail.js';
import { createProductsOrderFormElements } from './Components/ProductsOrderForm.js';

// Export the main sidebar component
export { default as ClientComponentsSidebar } from './ClientComponentsSidebar.js';

// Re-export component creators directly
export { createPhotographyNavbarElements } from './Components/PhotographyNavbar.js';
export { createCoursesNavbarElements } from './Components/CoursesNavbar.js';
export { createCoursesTopHeaderElements } from './Components/CoursesTopHeader.js';
export { createCoursesAboutElements } from './Components/CoursesAbout.js';
export { createSolarInstallationTopHeaderElements } from './Components/SolarInstallationTopHeader.js';
export { createSolarInstallationNavbarElements } from './Components/SolarInstallationNavbar.js';
export { createHerbalSoapNavbarElements } from './Components/HerbalSoapNavbar.js';
export { createPhotographyHeroElements } from './Components/PhotographyHero.js';
export { createCoursesHeroElements } from './Components/CoursesHero.js';
export { createSolarInstallationHeroElements } from './Components/SolarInstallationHero.js';
export { createSolarInstallationAboutElements } from './Components/SolarInstallationAbout.js';
export { createSolarInstallationIndustriesElements } from './Components/SolarInstallationIndustries.js';
export { createSolarInstallationCertificationsElements } from './Components/SolarInstallationCertifications.js';
export { createSolarInstallationProjectGalleryElements } from './Components/SolarInstallationProjectGallery.js';
export { createSolarInstallationTestimonialsElements } from './Components/SolarInstallationTestimonials.js';
export { createSolarInstallationContactElements } from './Components/SolarInstallationContact.js';
export { createSolarInstallationQuoteElements } from './Components/SolarInstallationQuote.js';
export { createSolarInstallationCCTVServiceElements } from './Components/SolarInstallationCCTVService.js';
export { createSolarInstallationDoorLockServiceElements } from './Components/SolarInstallationDoorLockService.js';
export { createSolarInstallationIntercomServiceElements } from './Components/SolarInstallationIntercomService.js';
export { createSolarInstallationMaintenanceServiceElements } from './Components/SolarInstallationMaintenanceService.js';
export { createSolarInstallationFooterElements } from './Components/SolarInstallationFooter.js';
export { createCoursesDetailsElements } from './Components/CoursesDetails.js';
export { createCoursesTestimonialsElements } from './Components/CoursesTestimonials.js';
export { createCourseDetailDigitalMarketingElements } from './Components/CourseDetailDigitalMarketing.js';
export { createCourseDetailComputerOperatorElements } from './Components/CourseDetailComputerOperator.js';
export { createCourseDetailTextileDesigningElements } from './Components/CourseDetailTextileDesigning.js';
export { createCourseDetailImportExportElements } from './Components/CourseDetailImportExport.js';
export { createCourseDetailDressMakingElements } from './Components/CourseDetailDressMaking.js';
export { createCourseDetailBeauticianElements } from './Components/CourseDetailBeautician.js';
export { createCourseDetailElectricianElements } from './Components/CourseDetailElectrician.js';
export { createCoursesContactElements } from './Components/CoursesContact.js';
export { createCoursesEnrollmentFormElements } from './Components/CoursesEnrollmentForm.js';
export { createCoursesFooterElements } from './Components/CoursesFooter.js';
export { createPhotographyAboutElements } from './Components/PhotographyAbout.js';
export { createPhotographyServicesElements } from './Components/PhotographyServices.js';
export { createPhotographyIndustriesElements } from './Components/PhotographyIndustries.js';
export { createPhotographyGalleryElements } from './Components/PhotographyGallery.js';
export { createPhotographyTestimonialsElements } from './Components/PhotographyTestimonials.js';
export { createPhotographyContactElements } from './Components/PhotographyContact.js';
export { createPhotographyFooterElements } from './Components/PhotographyFooter.js';
export { createWeddingPhotographyGalleryElements } from './Components/WeddingPhotographyGallery.js';
export { createPortraitSessionsGalleryElements } from './Components/PortraitSessionsGallery.js';
export { createEventPhotographyGalleryElements } from './Components/EventPhotographyGallery.js';
export { createCommercialWorkGalleryElements } from './Components/CommercialWorkGallery.js';
export { createNatureLandscapeGalleryElements } from './Components/NatureLandscapeGallery.js';
export { createHerbalSoapHeroElements } from './Components/HerbalSoapHero.js';
export { createHerbalSoapProductsElements } from './Components/HerbalSoapProducts.js';
export { createHerbalSoapAboutElements } from './Components/HerbalSoapAbout.js';
export { createHerbalSoapIngredientsElements } from './Components/HerbalSoapIngredients.js';
export { createHerbalSoapCertificationsElements } from './Components/HerbalSoapCertifications.js';
export { createHerbalSoapContactElements } from './Components/HerbalSoapContact.js';
export { createHerbalSoapFooterElements } from './Components/HerbalSoapFooter.js';
export { createHerbalSoapTestimonialsElements } from './Components/HerbalSoapTestimonials.js';
export { createHerbalSoapDetailElements } from './Components/HerbalSoapDetail.js';
export { createUbtanDetailElements } from './Components/UbtanDetail.js';
export { createHerbalFacewashDetailElements } from './Components/HerbalFacewashDetail.js';
export { createProductsOrderFormElements } from './Components/ProductsOrderForm.js';

// Component metadata for organization and discovery
export const componentMetadata = {
  PhotographyNavbar: {
    category: 'Navigation',
    description: 'Professional photography website navigation bar',
    tags: ['navbar', 'navigation', 'photography', 'responsive']
  },
  CoursesNavbar: {
    category: 'Navigation',
    description: 'Modern online courses website navigation bar with course categories and user actions',
    tags: ['navbar', 'navigation', 'courses', 'education', 'modern', 'responsive', 'cta']
  },
  CoursesTopHeader: {
    category: 'Navigation',
    description: 'Small top header bar with company information including address, phone number, email, and social icons for courses website',
    tags: ['top-header', 'header-bar', 'contact-info', 'social-icons', 'courses', 'education', 'company-info', 'responsive']
  },
  CoursesAbout: {
    category: 'Content',
    description: 'Courses themed about section with institute profile, mission, core values, and educational philosophy featuring modern indigo/purple styling',
    tags: ['about', 'institute', 'mission', 'values', 'courses', 'education', 'modern', 'indigo', 'purple', 'responsive']
  },
  SolarInstallationTopHeader: {
    category: 'Navigation',
    description: 'Small top header bar with company information including address, phone number, and social icons for solar installation business',
    tags: ['top-header', 'header-bar', 'contact-info', 'social-icons', 'solar', 'energy', 'company-info', 'responsive']
  },
  SolarInstallationNavbar: {
    category: 'Navigation',
    description: 'Professional solar installation business navigation bar with clean energy themed colors',
    tags: ['navbar', 'navigation', 'solar', 'energy', 'business', 'responsive', 'green', 'blue']
  },
  HerbalSoapNavbar: {
    category: 'Navigation',
    description: 'Organic herbal soap business navigation bar with natural green and earth-toned styling',
    tags: ['navbar', 'navigation', 'herbal', 'organic', 'soap', 'natural', 'green', 'earth-tones', 'responsive']
  },
  HerbalSoapHero: {
    category: 'Content',
    description: 'Organic herbal soap hero section with natural green styling, product showcase, and compelling call-to-action',
    tags: ['hero', 'herbal', 'organic', 'soap', 'natural', 'green', 'product', 'cta', 'stats', 'responsive']
  },
  PhotographyHero: {
    category: 'Content',
    description: 'Elegant photography hero section with stats and call-to-action',
    tags: ['hero', 'photography', 'banner', 'stats', 'cta']
  },
  CoursesHero: {
    category: 'Content',
    description: 'Modern online courses hero section with features, stats, and enrollment CTAs',
    tags: ['hero', 'courses', 'education', 'features', 'stats', 'cta', 'modern']
  },
  SolarInstallationHero: {
    category: 'Content',
    description: 'Professional solar installation hero section with clean energy themed design and stats',
    tags: ['hero', 'solar', 'energy', 'installation', 'stats', 'cta', 'clean-energy', 'green']
  },
  SolarInstallationAbout: {
    category: 'Content',
    description: 'Professional solar installation about section showcasing company services and mission',
    tags: ['about', 'solar', 'energy', 'services', 'company', 'mission', 'installation', 'repair']
  },
  SolarInstallationIndustries: {
    category: 'Content',
    description: 'Industries and clients showcase with interactive cards and statistics',
    tags: ['industries', 'clients', 'solar', 'energy', 'business', 'portfolio', 'cards', 'stats']
  },
  SolarInstallationCertifications: {
    category: 'Content',
    description: 'Professional certifications and awards showcase demonstrating industry credentials and recognitions',
    tags: ['certifications', 'awards', 'credentials', 'solar', 'energy', 'professional', 'recognition', 'trust']
  },
  SolarInstallationProjectGallery: {
    category: 'Gallery',
    description: 'Project gallery showcasing completed solar installations categorized by residential, commercial, and industrial sectors',
    tags: ['gallery', 'projects', 'portfolio', 'solar', 'energy', 'residential', 'commercial', 'industrial', 'showcase']
  },
  SolarInstallationTestimonials: {
    category: 'Content',
    description: 'Customer testimonials slider showcasing client feedback for solar installation and security services',
    tags: ['testimonials', 'reviews', 'slider', 'solar', 'energy', 'clients', 'feedback', 'security', 'installation']
  },
  SolarInstallationContact: {
    category: 'Content',
    description: 'Professional contact section with form and contact information for solar installation services',
    tags: ['contact', 'form', 'solar', 'energy', 'communication', 'quote', 'consultation', 'whitish-bg']
  },
  SolarInstallationQuote: {
    category: 'Content',
    description: 'Comprehensive quote request form with detailed property information, energy requirements, and service selection for solar installations',
    tags: ['quote', 'form', 'solar', 'energy', 'detailed', 'property', 'requirements', 'services', 'whitish-bg']
  },
  SolarInstallationCCTVService: {
    category: 'Services',
    description: 'Detailed CCTV installation and repair service page with features, packages, and comprehensive surveillance solutions',
    tags: ['cctv', 'surveillance', 'security', 'installation', 'repair', 'monitoring', 'cameras', 'service-detail']
  },
  SolarInstallationDoorLockService: {
    category: 'Services',
    description: 'Detailed electrical door lock systems service page with smart access control solutions and security features',
    tags: ['door-lock', 'access-control', 'security', 'smart-locks', 'keyless', 'biometric', 'electrical', 'service-detail']
  },
  SolarInstallationIntercomService: {
    category: 'Services',
    description: 'Detailed intercom and PABX systems service page with communication infrastructure solutions and networking',
    tags: ['intercom', 'pabx', 'communication', 'infrastructure', 'networking', 'telephone', 'ip-systems', 'service-detail']
  },
  SolarInstallationMaintenanceService: {
    category: 'Services',
    description: 'Detailed solar system maintenance service page with cleaning, monitoring, and preventive care packages',
    tags: ['maintenance', 'solar', 'cleaning', 'monitoring', 'preventive', 'performance', 'optimization', 'service-detail']
  },
  SolarInstallationFooter: {
    category: 'Layout',
    description: 'Professional solar installation footer with bluish background, company info, services, contact details, and social links',
    tags: ['footer', 'solar', 'energy', 'layout', 'contact', 'social', 'bluish', 'professional', 'responsive']
  },
  CoursesDetails: {
    category: 'Content',
    description: 'Featured courses showcase with detailed information, stats, pricing, and course detail buttons',
    tags: ['courses', 'education', 'cards', 'pricing', 'stats', 'cta', 'modern', 'details']
  },
  CoursesTestimonials: {
    category: 'Content',
    description: 'Student testimonials slider with success stories, ratings, and achievements',
    tags: ['testimonials', 'reviews', 'slider', 'courses', 'education', 'students', 'success', 'modern']
  },
  CourseDetailDigitalMarketing: {
    category: 'Content',
    description: 'Comprehensive digital marketing course detail page with curriculum, instructor info, and enrollment',
    tags: ['course', 'detail', 'digital-marketing', 'education', 'curriculum', 'instructor', 'enrollment', 'modern']
  },
  CourseDetailComputerOperator: {
    category: 'Content',
    description: 'Computer operator course detail page with MS Office training, curriculum, and enrollment options',
    tags: ['course', 'detail', 'computer-operator', 'education', 'ms-office', 'curriculum', 'instructor', 'enrollment']
  },
  CourseDetailTextileDesigning: {
    category: 'Content',
    description: 'Textile designing course detail page with fabric design, pattern making, and creative curriculum',
    tags: ['course', 'detail', 'textile-design', 'education', 'fashion', 'curriculum', 'instructor', 'enrollment']
  },
  CourseDetailImportExport: {
    category: 'Content',
    description: 'Import export procedure course detail page with trade documentation and international commerce training',
    tags: ['course', 'detail', 'import-export', 'education', 'trade', 'curriculum', 'instructor', 'enrollment']
  },
  CourseDetailDressMaking: {
    category: 'Content',
    description: 'Professional dress making course detail page with tailoring, pattern cutting, and garment construction',
    tags: ['course', 'detail', 'dress-making', 'education', 'tailoring', 'curriculum', 'instructor', 'enrollment']
  },
  CourseDetailBeautician: {
    category: 'Content',
    description: 'Professional beautician course detail page with cosmetology, makeup artistry, and beauty treatments',
    tags: ['course', 'detail', 'beautician', 'education', 'cosmetology', 'curriculum', 'instructor', 'enrollment']
  },
  CourseDetailElectrician: {
    category: 'Content',
    description: 'Professional electrician training course detail page with electrical systems and safety protocols',
    tags: ['course', 'detail', 'electrician', 'education', 'electrical', 'curriculum', 'instructor', 'enrollment']
  },
  CoursesContact: {
    category: 'Content',
    description: 'Modern contact section for online courses website with form, contact info, and social links',
    tags: ['contact', 'form', 'courses', 'education', 'communication', 'info', 'modern', 'responsive']
  },
  CoursesEnrollmentForm: {
    category: 'Content',
    description: 'Interactive enrollment form with multiple course selection, beautiful course cards, and student information fields',
    tags: ['enrollment', 'form', 'courses', 'education', 'selection', 'interactive', 'modern', 'responsive']
  },
  CoursesFooter: {
    category: 'Layout',
    description: 'Modern footer for online courses website with course links, company info, newsletter signup, and social media',
    tags: ['footer', 'courses', 'education', 'links', 'newsletter', 'social', 'modern', 'responsive']
  },
  PhotographyAbout: {
    category: 'Content',
    description: 'Professional about section with photographer profile, story, and skills',
    tags: ['about', 'profile', 'story', 'skills', 'photography', 'biography']
  },
  PhotographyServices: {
    category: 'Content',
    description: 'Professional photography services showcase with pricing and features',
    tags: ['services', 'photography', 'pricing', 'features', 'cards']
  },
  PhotographyIndustries: {
    category: 'Content',
    description: 'Industries and clients showcase with interactive cards and statistics',
    tags: ['industries', 'clients', 'photography', 'portfolio', 'cards', 'stats']
  },
  PhotographyGallery: {
    category: 'Content',
    description: 'Photography gallery with tabbed categories and image showcase',
    tags: ['gallery', 'photography', 'portfolio', 'tabs', 'images', 'showcase']
  },
  PhotographyTestimonials: {
    category: 'Content',
    description: 'Client testimonials slider with photography theme and elegant design',
    tags: ['testimonials', 'reviews', 'slider', 'photography', 'clients', 'feedback']
  },
  PhotographyContact: {
    category: 'Content',
    description: 'Professional contact section with form and contact information',
    tags: ['contact', 'form', 'photography', 'communication', 'info']
  },
  PhotographyFooter: {
    category: 'Layout',
    description: 'Professional footer with links, contact info, and social media',
    tags: ['footer', 'navigation', 'contact', 'social', 'links', 'photography']
  },
  WeddingPhotographyGallery: {
    category: 'Gallery',
    description: 'Wedding photography portfolio gallery with romantic styling and 12+ wedding images',
    tags: ['gallery', 'wedding', 'photography', 'portfolio', 'romantic', 'images', 'showcase']
  },
  PortraitSessionsGallery: {
    category: 'Gallery',
    description: 'Portrait sessions portfolio gallery with professional styling and 12+ portrait images',
    tags: ['gallery', 'portrait', 'photography', 'portfolio', 'professional', 'images', 'showcase']
  },
  EventPhotographyGallery: {
    category: 'Gallery',
    description: 'Event photography portfolio gallery with dynamic styling and 12+ event images',
    tags: ['gallery', 'event', 'photography', 'portfolio', 'dynamic', 'images', 'showcase']
  },
  CommercialWorkGallery: {
    category: 'Gallery',
    description: 'Commercial work portfolio gallery with corporate styling and 12+ commercial images',
    tags: ['gallery', 'commercial', 'photography', 'portfolio', 'corporate', 'images', 'showcase']
  },
  NatureLandscapeGallery: {
    category: 'Gallery',
    description: 'Nature landscape portfolio gallery with organic styling and 12+ nature images',
    tags: ['gallery', 'nature', 'landscape', 'photography', 'portfolio', 'organic', 'images', 'showcase']
  },
  HerbalSoapProducts: {
    category: 'Content',
    description: 'Organic herbal products showcase with 3 product cards featuring images, prices, and order buttons',
    tags: ['products', 'herbal', 'organic', 'soap', 'cards', 'ecommerce', 'natural', 'green', 'responsive']
  },
  HerbalSoapAbout: {
    category: 'Content',
    description: 'Compelling about section with brand story, features, stats, and trust-building content for herbal soap business',
    tags: ['about', 'story', 'features', 'stats', 'herbal', 'organic', 'trust', 'brand', 'natural', 'green', 'responsive']
  },
  HerbalSoapIngredients: {
    category: 'Content',
    description: 'Natural ingredients showcase with 6 ingredient cards featuring images, benefits, and detailed descriptions',
    tags: ['ingredients', 'natural', 'herbal', 'organic', 'benefits', 'cards', 'education', 'trust', 'green', 'responsive']
  },
  HerbalSoapCertifications: {
    category: 'Content',
    description: 'Herbal soap certifications and awards showcase demonstrating industry credentials and recognitions',
    tags: ['certifications', 'awards', 'credentials', 'herbal', 'organic', 'professional', 'recognition', 'trust']
  },
  HerbalSoapContact: {
    category: 'Content',
    description: 'Professional contact section with form and contact information for herbal soap business',
    tags: ['contact', 'form', 'herbal', 'organic', 'communication', 'info', 'natural', 'green', 'responsive']
  },
  HerbalSoapFooter: {
    category: 'Layout',
    description: 'Professional herbal soap footer with natural green background, company info, product links, contact details, and social media',
    tags: ['footer', 'herbal', 'organic', 'layout', 'contact', 'social', 'natural', 'green', 'professional', 'responsive']
  },
  HerbalSoapTestimonials: {
    category: 'Content',
    description: 'Customer testimonials slider showcasing client feedback for herbal soap products with natural green styling',
    tags: ['testimonials', 'reviews', 'slider', 'herbal', 'organic', 'customers', 'feedback', 'natural', 'green', 'responsive']
  },
  HerbalSoapDetail: {
    category: 'Content',
    description: 'Comprehensive herbal soap product detail page with images, specifications, ingredients, benefits, and purchase options',
    tags: ['detail', 'product', 'herbal', 'organic', 'soap', 'ecommerce', 'specifications', 'ingredients', 'benefits', 'natural', 'green', 'responsive']
  },
  UbtanDetail: {
    category: 'Content',
    description: 'Traditional Ubtan product detail page with Ayurvedic formula, natural ingredients, and comprehensive product information',
    tags: ['detail', 'product', 'ubtan', 'ayurvedic', 'traditional', 'herbal', 'face-pack', 'natural', 'specifications', 'ingredients', 'benefits', 'green', 'responsive']
  },
  HerbalFacewashDetail: {
    category: 'Content',
    description: 'Organic herbal face wash product detail page with cleansing benefits, natural ingredients, and skincare specifications',
    tags: ['detail', 'product', 'facewash', 'herbal', 'organic', 'cleanser', 'skincare', 'natural', 'specifications', 'ingredients', 'benefits', 'green', 'responsive']
  },
  ProductsOrderForm: {
    category: 'Content',
    description: 'Interactive product order form with multiple product selection, beautiful product cards, and customer information fields for herbal soap business',
    tags: ['order', 'form', 'products', 'herbal', 'organic', 'selection', 'interactive', 'natural', 'green', 'responsive', 'ecommerce']
  }
};

// Auto-discovery function to get all available components
export const getAvailableComponents = () => {
  const components = [];
  
  // Define available components with their functions
  const availableComponents = [
    { name: 'HerbalSoapNavbar', createFunction: createHerbalSoapNavbarElements },
    { name: 'HerbalSoapHero', createFunction: createHerbalSoapHeroElements },
    { name: 'HerbalSoapProducts', createFunction: createHerbalSoapProductsElements },
    { name: 'HerbalSoapAbout', createFunction: createHerbalSoapAboutElements },
    { name: 'HerbalSoapIngredients', createFunction: createHerbalSoapIngredientsElements },
    { name: 'HerbalSoapCertifications', createFunction: createHerbalSoapCertificationsElements },
    { name: 'HerbalSoapContact', createFunction: createHerbalSoapContactElements },
    { name: 'HerbalSoapFooter', createFunction: createHerbalSoapFooterElements },
    { name: 'HerbalSoapTestimonials', createFunction: createHerbalSoapTestimonialsElements },
    { name: 'HerbalSoapDetail', createFunction: createHerbalSoapDetailElements },
    { name: 'UbtanDetail', createFunction: createUbtanDetailElements },
    { name: 'HerbalFacewashDetail', createFunction: createHerbalFacewashDetailElements },
    // { name: 'ProductsOrderForm', createFunction: createProductsOrderFormElements },
    // { name: 'SolarInstallationTopHeader', createFunction: createSolarInstallationTopHeaderElements },
    // { name: 'SolarInstallationNavbar', createFunction: createSolarInstallationNavbarElements },
    // { name: 'SolarInstallationHero', createFunction: createSolarInstallationHeroElements },
    // { name: 'SolarInstallationAbout', createFunction: createSolarInstallationAboutElements },
    // { name: 'SolarInstallationIndustries', createFunction: createSolarInstallationIndustriesElements },
    // { name: 'SolarInstallationCertifications', createFunction: createSolarInstallationCertificationsElements },
    // { name: 'SolarInstallationProjectGallery', createFunction: createSolarInstallationProjectGalleryElements },
    // { name: 'SolarInstallationTestimonials', createFunction: createSolarInstallationTestimonialsElements },
    // { name: 'SolarInstallationContact', createFunction: createSolarInstallationContactElements },
    // { name: 'SolarInstallationQuote', createFunction: createSolarInstallationQuoteElements },
    // { name: 'SolarInstallationCCTVService', createFunction: createSolarInstallationCCTVServiceElements },
    // { name: 'SolarInstallationDoorLockService', createFunction: createSolarInstallationDoorLockServiceElements },
    // { name: 'SolarInstallationIntercomService', createFunction: createSolarInstallationIntercomServiceElements },
    // { name: 'SolarInstallationMaintenanceService', createFunction: createSolarInstallationMaintenanceServiceElements },
    // { name: 'SolarInstallationFooter', createFunction: createSolarInstallationFooterElements },
    // { name: 'PhotographyNavbar', createFunction: createPhotographyNavbarElements },
    // { name: 'CoursesNavbar', createFunction: createCoursesNavbarElements },
    // { name: 'CoursesTopHeader', createFunction: createCoursesTopHeaderElements },
    // { name: 'CoursesAbout', createFunction: createCoursesAboutElements },
    // { name: 'PhotographyHero', createFunction: createPhotographyHeroElements },
    // { name: 'CoursesHero', createFunction: createCoursesHeroElements },
    // { name: 'CoursesDetails', createFunction: createCoursesDetailsElements },
    // { name: 'CoursesTestimonials', createFunction: createCoursesTestimonialsElements },
    // { name: 'CourseDetailDigitalMarketing', createFunction: createCourseDetailDigitalMarketingElements },
    // { name: 'CourseDetailComputerOperator', createFunction: createCourseDetailComputerOperatorElements },
    // { name: 'CourseDetailTextileDesigning', createFunction: createCourseDetailTextileDesigningElements },
    // { name: 'CourseDetailImportExport', createFunction: createCourseDetailImportExportElements },
    // { name: 'CourseDetailDressMaking', createFunction: createCourseDetailDressMakingElements },
    // { name: 'CourseDetailBeautician', createFunction: createCourseDetailBeauticianElements },
    // { name: 'CourseDetailElectrician', createFunction: createCourseDetailElectricianElements },
    // { name: 'CoursesContact', createFunction: createCoursesContactElements },
    // { name: 'CoursesEnrollmentForm', createFunction: createCoursesEnrollmentFormElements },
    // { name: 'CoursesFooter', createFunction: createCoursesFooterElements },
    // { name: 'PhotographyAbout', createFunction: createPhotographyAboutElements },
    // { name: 'PhotographyServices', createFunction: createPhotographyServicesElements },
    // { name: 'PhotographyIndustries', createFunction: createPhotographyIndustriesElements },
    // { name: 'PhotographyGallery', createFunction: createPhotographyGalleryElements },
    // { name: 'PhotographyTestimonials', createFunction: createPhotographyTestimonialsElements },
    // { name: 'PhotographyContact', createFunction: createPhotographyContactElements },
    // { name: 'PhotographyFooter', createFunction: createPhotographyFooterElements },
    // { name: 'WeddingPhotographyGallery', createFunction: createWeddingPhotographyGalleryElements },
    // { name: 'PortraitSessionsGallery', createFunction: createPortraitSessionsGalleryElements },
    // { name: 'EventPhotographyGallery', createFunction: createEventPhotographyGalleryElements },
    // { name: 'CommercialWorkGallery', createFunction: createCommercialWorkGalleryElements },
    // { name: 'NatureLandscapeGallery', createFunction: createNatureLandscapeGalleryElements }
  ];
  
  // Process each component
  availableComponents.forEach(({ name, createFunction }) => {
    if (createFunction && typeof createFunction === 'function') {
      const metadata = componentMetadata[name] || {};
      
      components.push({
        id: name.toLowerCase(),
        name: name,
        createFunction: createFunction,
        thumbnail: `https://via.placeholder.com/250x120?text=${name}+Component`,
        description: metadata.description || `Custom ${name} component`,
        category: metadata.category || 'General',
        tags: metadata.tags || []
      });
    }
  });
  
  return components;
}; 